import { render, staticRenderFns } from "./bankSet.vue?vue&type=template&id=2ab0518f&scoped=true&"
import script from "./bankSet.vue?vue&type=script&lang=js&"
export * from "./bankSet.vue?vue&type=script&lang=js&"
import style0 from "./bankSet.vue?vue&type=style&index=0&id=2ab0518f&prod&lang=scss&scoped=true&"
import style1 from "./bankSet.vue?vue&type=style&index=1&id=2ab0518f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0518f",
  null
  
)

export default component.exports